import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromAccountingDistributionExternal from './accounting-distribution-external.reducers';

export interface AccountingDistributionExternalState {
  stateData: fromAccountingDistributionExternal.State;
}

export interface State extends fromRoot.AppState {
  accountingDistributionExternal: AccountingDistributionExternalState;
}

export const reducers = {
  stateData: fromAccountingDistributionExternal.reducer
};

export const selectAccountingDistributionExternalState = createFeatureSelector<AccountingDistributionExternalState>('accountingDistributionExternal');

export const selectAccountingDistributionExternalStateData = createSelector(selectAccountingDistributionExternalState, (state: AccountingDistributionExternalState) => state.stateData);

export const getAccountingDistributionExternalState = createSelector(selectAccountingDistributionExternalStateData, fromAccountingDistributionExternal.getStateData);

export const getAccountingDistributionExternalScreenError = createSelector(selectAccountingDistributionExternalStateData, fromAccountingDistributionExternal.getError);

export const getAccountingDistributionExternalScreenPending = createSelector(selectAccountingDistributionExternalStateData, fromAccountingDistributionExternal.getPending);